import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import router from "@/router";

const firebaseConfig = {
  apiKey: "AIzaSyDIVHeXPL_H9nHt3jFbHvOrSJFgirGXfJo",
  authDomain: "biowatch-proto.firebaseapp.com",
  databaseURL: "https://biowatch-proto.firebaseio.com",
  projectId: "biowatch-proto",
  storageBucket: "biowatch-proto.appspot.com",
  messagingSenderId: "258714194002",
  appId: "1:258714194002:web:de91601f4633a0cf544f8b",
  measurementId: "G-2ERWQH7V19"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default {
  auth: firebase.auth(),
  login() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        console.log("LOGIN RESULT", result);
      })
      .catch(function(error) {
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.email;
        const credential = error.credential;
        // console.log(errorCode, errorMessage, email, credential);
      });
  },
  logout() {
    firebase
      .auth()
      .signOut()
      .then(function() {})
      .catch(function(error) {
        // console.log(error);
      });
  }
};

const firestore = firebaseApp.firestore();

export { firestore };
